// extracted by mini-css-extract-plugin
export default {"container":"TemplateSelector_container__+ME8E","templates":"TemplateSelector_templates__DVti6"};